import React from 'react';
import CellChipComponent from '../EForm/FormField/cell-chip';
import CellDropdownComponent from '../EForm/FormField/cell-dropdown';
import CellFileUploadComponent from '../EForm/FormField/cell-file-upload';
import CellBooleanComponent from '../EForm/FormField/cell-boolean';
import CellBooleanRadioComponent from "../EForm/FormField/cell-boolean-radio";
import CellMultiDropdownComponent from "../EForm/FormField/cell-multi-select";
import CellStringComponent from '../EForm/FormField/cell-string';
import CellNumberComponent from '../EForm/FormField/cell-number';
import PropTypes from 'prop-types';
import CellModelTermsComponent from "../EForm/FormField/cell-model-terms";

const FormFieldDictionary = {
    "string": CellStringComponent,
    "dropdown": CellDropdownComponent,
    "multi-select": CellMultiDropdownComponent,
    "file-upload": CellFileUploadComponent,
    "number": CellNumberComponent,
    "integer": CellNumberComponent,
    "boolean": CellBooleanComponent,
    "radio": CellBooleanRadioComponent,
    "array": CellChipComponent,
    "dynamic-dropdown": CellModelTermsComponent
};

const FormField = (props) => {
    const { type, ...otherProps } = props;
    const Component = FormFieldDictionary[type];

    if (!Component) {
        throw new Error(`Unsupported type: ${type}`);
    }

    return <Component {...otherProps} />;
};

FormField.propTypes = {
    type: PropTypes.oneOf(Object.keys(FormFieldDictionary)),
};

export default FormField;
